/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPowerButtonIcon24Regular = forwardRef('TechPowerButtonIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12.75 2a.75.75 0 0 0-1.5 0v9a.75.75 0 0 0 1.5 0V2Z" }),
        React.createElement("path", { d: "M7.423 5.136a.75.75 0 0 0-.832-1.248 9.75 9.75 0 1 0 10.832.01.75.75 0 1 0-.834 1.246 8.25 8.25 0 1 1-9.166-.008Z" })));
});
